import React from 'react';
import { 
  Box, 
  Typography, 
  Avatar, 
  Button 
} from '@mui/material';
import TaskIcon from '@mui/icons-material/CheckCircleOutline';
import AddIcon from '@mui/icons-material/Add';

const EmptyTaskCard = ({ 
  onAddTask, 
  title = "No Upcoming Tasks", 
  description = "No tasks scheduled for this lead. Create a new task to stay organized and track follow-ups.",
  buttonText = "Add Task",
  showButton = true,
  compact = false 
}) => {
  return (
    <Box sx={{ 
      p: compact ? 2.5 : 4, 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: compact ? 120 : 200
    }}>
      <Avatar 
        sx={{ 
          bgcolor: 'rgba(0, 168, 84, 0.1)', 
          color: '#00A854', 
          width: compact ? 40 : 56, 
          height: compact ? 40 : 56,
          margin: '0 auto',
          mb: compact ? 1.5 : 2,
          boxShadow: '0 4px 12px rgba(0, 168, 84, 0.2)'
        }}
      >
        <TaskIcon sx={{ fontSize: compact ? 20 : 28 }} />
      </Avatar>
      
      <Typography 
        variant={compact ? "subtitle1" : "h6"} 
        color="text.primary" 
        sx={{ 
          fontWeight: 600, 
          mb: compact ? 0.5 : 1,
          fontSize: compact ? '0.875rem' : '1.125rem'
        }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body2" 
        color="text.secondary" 
        sx={{ 
          lineHeight: 1.6, 
          mb: compact ? 1.5 : 2,
          fontSize: compact ? '0.813rem' : '0.875rem',
          maxWidth: 300
        }}
      >
        {description}
      </Typography>
      
      {showButton && onAddTask && (
        <Button 
          startIcon={<AddIcon sx={{ fontSize: compact ? '0.875rem' : '1rem' }} />}
          variant="contained"
          size="small"
          onClick={onAddTask}
          sx={{ 
            textTransform: 'none',
            fontSize: compact ? '0.813rem' : '0.875rem',
            fontWeight: 500,
            bgcolor: '#00A854',
            borderRadius: '6px',
            boxShadow: '0 2px 4px rgba(0, 168, 84, 0.2)',
            '&:hover': {
              bgcolor: '#00994A',
              boxShadow: '0 4px 8px rgba(0, 168, 84, 0.3)'
            }
          }}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default EmptyTaskCard; 